module.exports = __webpack_public_path__ + "img/869-37d515.png";